export const SET_INVOICES = "setInvoices";
export const SET_INVOICES_TOTAL = "setInvoicesTotal";
export const SET_INVOICE = "setInvoice";
export const SET_LOADING = "setLoading";

export default {
  [SET_INVOICES](state, supervisor_invoices) {
    state.supervisor_invoices = supervisor_invoices;
  },
  [SET_INVOICES_TOTAL](state, totalCount) {
    state.totalCount = totalCount;
  },
  [SET_INVOICE](state, supervisor_invoice) {
    state.supervisor_invoice = supervisor_invoice;
  },
  [SET_LOADING](state, loading) {
    state.loading = loading;
  },
};
